import { render, staticRenderFns } from "./RTrends.vue?vue&type=template&id=106456cb&scoped=true&"
import script from "./RTrends.vue?vue&type=script&lang=js&"
export * from "./RTrends.vue?vue&type=script&lang=js&"
import style0 from "./RTrends.vue?vue&type=style&index=0&id=106456cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106456cb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
